import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: '首页', icon: 'home'}
      }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/userCount',
    name: 'statistics',
    meta: {title: '统计管理', icon: 'ums'},
    children: [
      {
        path: 'activeCount',
        name: 'activeCount',
        component: () => import('@/views/statistics/activeCount/index'),
        meta: {title: '活跃量统计', icon: 'ums-admin'}
      },{
        path: 'divideCount',
        name: 'divideCount',
        component: () => import('@/views/statistics/divideCount/index'),
        meta: {title: '分成量统计', icon: 'ums-admin'}
      },{
        path: 'ecpmCount',
        name: 'ecpmCount',
        component: () => import('@/views/statistics/ecpmCount/index'),
        meta: {title: 'ECPM量统计', icon: 'ums-admin'}
      },{
        path: 'exchangeCount',
        name: 'exchangeCount',
        component: () => import('@/views/statistics/exchangeCount/index'),
        meta: {title: '兑换量统计', icon: 'ums-admin'}
      },{
        path: 'scoreCount',
        name: 'scoreCount',
        component: () => import('@/views/statistics/scoreCount/index'),
        meta: {title: '积分量统计', icon: 'ums-admin'}
      },{
        path: 'userCount',
        name: 'userCount',
        component: () => import('@/views/statistics/userCount/index'),
        meta: {title: '用户量统计', icon: 'ums-admin'}
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限管理', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/memberList',
    name: 'member',
    meta: {title: '成员管理', icon: 'ums'},
    children: [
      {
        path: 'subStatistics',
        name: 'subStatistics',
        component: () => import('@/views/member/statistics/index'),
        meta: {title: '下级积分统计', icon: 'ums-admin'}
      },
      {
        path: 'memberList',
        name: 'memberList',
        component: () => import('@/views/member/memberList/index'),
        meta: {title: '成员列表', icon: 'ums-admin'}
      },
      {
        path: 'agentList',
        name: 'agentList',
        component: () => import('@/views/member/agentList/index'),
        meta: {title: '代理列表', icon: 'ums-admin'}
      },
      {
        path: 'subMemberList',
        name: 'subMemberList',
        component: () => import('@/views/member/subMemberList/index'),
        meta: {title: '下级成员列表', icon: 'ums-admin'}
      },
      {
        path: 'memberDeviceList',
        name: 'memberDeviceList',
        component: () => import('@/views/member/memberDeviceList/index'),
        meta: {title: '成员设备列表', icon: 'ums-admin'}
      },
      {
        path: 'memberIpList',
        name: 'memberIpList',
        component: () => import('@/views/member/memberIpList/index'),
        meta: {title: '成员IP列表', icon: 'ums-admin'}
      },
    ]
  },
  {
    path: '/config',
    component: Layout,
    redirect: '/config/commonConfig',
    name: 'config',
    meta: {title: '配置管理', icon: 'ums'},
    children: [
      {
        path: 'commonConfig',
        name: 'commonConfig',
        component: () => import('@/views/config/commonConfig/index'),
        meta: {title: '版本配置', icon: 'ums-admin'}
      },
      {
        path: 'normalConfig',
        name: 'normalConfig',
        component: () => import('@/views/config/normalConfig/index'),
        meta: {title: '通用配置', icon: 'ums-admin'}
      },
      {
        path: 'adPositionConfig',
        name: 'adPositionConfig',
        component: () => import('@/views/config/adPositionConfig/index'),
        meta: {title: '广告位置配置', icon: 'ums-admin'}
      },
    ]
  },
  {
    path: '/score',
    component: Layout,
    redirect: '/score/scoreRecordList',
    name: 'score',
    meta: {title: '积分管理', icon: 'ums'},
    children: [
      {
        path: 'scoreRecordList',
        name: 'scoreRecordList',
        component: () => import('@/views/score/scoreRecordList/index'),
        meta: {title: '积分记录列表', icon: 'ums-admin'}
      },
      {
        path: 'goldRecordList',
        name: 'goldRecordList',
        component: () => import('@/views/score/goldRecordList/index'),
        meta: {title: '金币记录列表', icon: 'ums-admin'}
      },
      {
        path: 'diamondRecordList',
        name: 'diamondRecordList',
        component: () => import('@/views/score/diamondRecordList/index'),
        meta: {title: '钻石记录列表', icon: 'ums-admin'}
      },
      {
        path: 'ticketRecordList',
        name: 'ticketRecordList',
        component: () => import('@/views/score/ticketRecordList/index'),
        meta: {title: '票据记录列表', icon: 'ums-admin'}
      },
    ]
  },
  {
    path: '/business',
    component: Layout,
    redirect: '/business/categoryList',
    name: 'business',
    meta: {title: '分类管理', icon: 'ums'},
    children: [
      {
        path: 'recommendList',
        name: 'recommendList',
        component: () => import('@/views/business/recommendList/index'),
        meta: {title: '推荐列表', icon: 'ums-admin'}
      },
      {
        path: 'categoryList',
        name: 'categoryList',
        component: () => import('@/views/business/categoryList/index'),
        meta: {title: '分类列表', icon: 'ums-admin'}
      },
      {
        path: 'regionList',
        name: 'regionList',
        component: () => import('@/views/business/regionList/index'),
        meta: {title: '地区列表', icon: 'ums-admin'}
      },
      {
        path: 'storeList',
        name: 'storeList',
        component: () => import('@/views/business/storeList/index'),
        meta: {title: '店铺列表', icon: 'ums-admin'}
      },
      {
        path: 'messageList',
        name: 'messageList',
        component: () => import('@/views/business/messageList/index'),
        meta: {title: '消息列表', icon: 'ums-admin'}
      },
    ]
  },
  {
    path: '/riskUser',
    component: Layout,
    redirect: '/riskUser/index',
    name: 'riskUser',
    meta: {title: '风控管理', icon: 'ums'},
    children: [
      {
        path: 'riskUser',
        name: 'riskUser',
        component: () => import('@/views/riskUser/index'),
        meta: {title: '风控列表', icon: 'ums-admin'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js